module.exports = __webpack_public_path__ + "static/media/OfficinaSans-Book.97adafc1.otf";